import styles from './ProductTab.module.scss';
import PaginationComponent from '../../../global/Components/Pagination/PaginationComponent';
import Comments from '../../../global/Components/Items/Comment/Comments';

export default function CommentsSection(props) {
  return (
    <>
        <div id={`comments`}>
            <h3 className={`py-4`}>Ask From the Seller</h3>
            <div className={`ms-2 mx-sm-4 mb-5`}>
                <Comments onCallProductComment={props.onCallProductComment} productOwnerId={props.productOwnerId} data={props.comments ? props.comments : false} 
                        currentPage={props.currentPage} 
                        setCurrentPage={props.setCurrentPage}  
                        metaData={props.metaData}></Comments>
            </div>
                {
                props.metaData &&
                    props.metaData.last_page > 1 
                    ? (
                        <PaginationComponent 
                        currentPage={props.currentPage} 
                        setCurrentPage={props.setCurrentPage}  
                        metaData={props.metaData}/>
                    ) 
                    : ('')
                }
        </div>
    </>
  )
}
